import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { ProjetIndicateurService } from '../../../plananalytique/programme/projet-indicateur/projet-indicateur.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-stats-pai',
  standalone: false,
  templateUrl: './stats-pai.component.html',
  styleUrl: './stats-pai.component.scss'
})

export class StatsPaiComponent {

  annee: any;
  items: any[] = [];
  hierarchicalItems: any[] = [];

  firstProjets: number = 0;
  rowsProjets: number = 10;
  totalRecords: number = 0;
  paginatedProjets: any[] = [];

  user: any;
  directionItems: any[] = [];
  isLoading: boolean = false;
  dateFin: any;
  dateDebut: any;

  private openProgrammes = new Set<number>();
  private openActions    = new Set<number>();
  private openActivites  = new Set<number>();

  // Index rapide parent_id par id (pour remonter la hiérarchie)
  private parentIndex: { [id: number]: number } = {};

  constructor(
    private modalService: NgbModal,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private projetService: ProjetIndicateurService,
    private ngxService: NgxUiLoaderService,
    private router: Router
  ) {
    this.annee = this.localstorage.getExerciceToUserToSuivieEvaluation();
    // Initialize dates based on the exercise year
    if (this.annee) {
      this.dateDebut = `${this.annee}-01-01`;
      this.dateFin = `${this.annee}-12-31`;
    }
  }

  ngOnInit() {
    this.user = this.localstorage.getInfoUserToService()?.data;
  }


  getStatistique() {
     if (this.dateDebut === null || this.dateDebut === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de début', life: 3000 });
      return;
    }
    if (this.dateFin === null || this.dateFin === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de fin', life: 3000 });
      return;
    }
    this.ngxService.start();
    const requestData = {
      date_debut: this.dateDebut,
      date_fin: this.dateFin,
      user_reference: this.user.reference,
      type_operation: 'data'
    };

    this.paramservice.getStatsPai(requestData).subscribe(
      (response: any) => {
        this.ngxService.stop();
        this.loadData(response.data);
      },
      (error) => {
        this.ngxService.stop();
        this.messageService.add({ severity: 'error', summary: 'TEP', detail: error, life: 3000 });
      }
    );
  }

  private loadData(data: any[]) {
    this.items = data;
    this.hierarchicalItems = data; // déjà ordonnés par le backend

    // Construire l'index parent
    this.parentIndex = {};
    data.forEach(item => {
      if (item.parent_id != null) {
        this.parentIndex[item.id] = item.parent_id;
      }
    });

    // Par défaut : tout ouvert
    this.expandAll();

    this.totalRecords = data.length;
    this.updatePaginatedProjets();
  }


  toggleProgramme(id: number) {
    if (this.openProgrammes.has(id)) {
      this.openProgrammes.delete(id);
    } else {
      this.openProgrammes.add(id);
    }
  }

  toggleAction(id: number) {
    if (this.openActions.has(id)) {
      this.openActions.delete(id);
    } else {
      this.openActions.add(id);
    }
  }

  toggleActivite(id: number) {
    if (this.openActivites.has(id)) {
      this.openActivites.delete(id);
    } else {
      this.openActivites.add(id);
    }
  }

  /** Ouvre tous les niveaux */
  expandAll() {
    this.hierarchicalItems.forEach(item => {
      if (item.type === 'programme') this.openProgrammes.add(item.id);
      if (item.type === 'action')    this.openActions.add(item.id);
      if (item.type === 'activite')  this.openActivites.add(item.id);
    });
  }

  collapseAll() {
    this.openProgrammes.clear();
    this.openActions.clear();
    this.openActivites.clear();
  }


  isProgrammeOpen(id: number): boolean {
    return this.openProgrammes.has(id);
  }

  isActionOpen(id: number): boolean {
    return this.openActions.has(id);
  }

  isActiviteOpen(id: number): boolean {
    return this.openActivites.has(id);
  }


  isActiviteVisible(item: any): boolean {
    const actionId = item.parent_id;
    if (!this.isActionOpen(actionId)) return false;

    // Trouver le  parent de l'action
    const programmeId = this.parentIndex[actionId];
    return programmeId != null ? this.isProgrammeOpen(programmeId) : false;
  }


  isTacheVisible(item: any): boolean {
    const activiteId = item.parent_id;
    if (!this.isActiviteOpen(activiteId)) return false;

    // Trouver l'action parente de l'activité
    const actionId = this.parentIndex[activiteId];
    if (actionId == null || !this.isActionOpen(actionId)) return false;

    // Trouver le programme parent de l'action
    const programmeId = this.parentIndex[actionId];
    return programmeId != null ? this.isProgrammeOpen(programmeId) : false;
  }


  onPageChangeProjets(event: any) {
    this.firstProjets = event.page * this.rowsProjets;
    this.updatePaginatedProjets();
  }

  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.hierarchicalItems.slice(start, end);
  }


  exportToDocument(typeDoc: string) {
    // Ensure dates are set with defaults if not provided
    if (!this.dateDebut || this.dateDebut === '') {
      this.dateDebut = this.annee ? `${this.annee}-01-01` : '';
    }
    if (!this.dateFin || this.dateFin === '') {
      this.dateFin = this.annee ? `${this.annee}-12-31` : '';
    }

    if (this.dateDebut === '' || this.dateDebut === null || this.dateDebut === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de début', life: 3000 });
      return;
    }
    if (this.dateFin === '' || this.dateFin === null || this.dateFin === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de fin', life: 3000 });
      return;
    }
    const requestData = {
      date_debut: this.dateDebut,
      date_fin: this.dateFin,
      user_reference: this.user.reference,
      type_operation: typeDoc
    };
    this.ngxService.start();

    this.paramservice.getStatsPaiDoc(requestData).subscribe(
      (response: Blob) => {
        let filename = '';
        let mimeType = '';
        let successMessage = '';

        if (typeDoc === 'pdf') {
          filename = 'Statistiques_pai.pdf';
          mimeType = 'application/pdf';
          successMessage = 'Le fichier PDF a été téléchargé avec succès';
          const blob = new Blob([response], { type: mimeType });
          window.open(URL.createObjectURL(blob), '_blank');
        } else {
          filename = 'Statistiques_pai.xlsx';
          mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          successMessage = 'Le fichier Excel a été téléchargé avec succès';
          FileSaver.saveAs(new Blob([response], { type: mimeType }), filename);
        }

        this.ngxService.stop();
        this.messageService.add({ severity: 'success', summary: 'Téléchargement réussi', detail: successMessage, life: 3000 });
      },
      (error) => {
        console.error('Erreur export', error);
        this.ngxService.stop();
      }
    );
  }

  getDirection() {
    this.paramservice.fetchDataDirection().subscribe(
      (response: any) => { this.directionItems = response.data; },
      (error) => { console.error('Erreur direction', error); }
    );
  }
}
